/*
 * inselvolt Kompatibilitätsberater — Preisdaten.
 *
 * GENERIERT von v2/tools/preise-generieren.js — NICHT von Hand bearbeiten.
 * Quelle: öffentlicher Produktkatalog https://inselvolt.de/products.json, abgerufen am 2026-09-19.
 * Preise sind Tagespreise des Shops (inkl. laufender Aktionen) und veralten.
 * Neu erzeugen: node v2/tools/preise-generieren.js   (Anleitung: v2/DATENPFLEGE.md, Rezept E)
 * Kein Preis gefunden ⇒ Eintrag fehlt ⇒ UI zeigt „Preis auf Anfrage".
 *
 * Diese Datei ist im Betrieb der RÜCKFALL: Zur Laufzeit holt app/preisquelle.js
 * Preise und Verfügbarkeit live über die Storefront-API. Erst wenn das scheitert,
 * rechnet der Berater mit den Werten hier — und weist das sichtbar samt Datum aus.
 * Außerdem ist sie die Zuordnungstabelle: Nur was hier steht, bekommt einen Preis.
 */
(function (root) {
  'use strict';
  var PREISE = {
    quelle: {
      titel: 'inselvolt.de Produktkatalog (products.json)',
      url: 'https://inselvolt.de',
      abruf_datum: '2026-09-19',
    },
    eintraege: [
    {
      "typ": "zubehoer",
      "familie": "kostal-plenticoin",
      "schluessel": "karte-de",
      "preis_cents": 14814,
      "verfuegbar": true,
      "handle": "kostal-plenticoin-universalgutschein-fuer-funktionsfreischaltungen",
      "variante_id": 59242196369742,
      "shop_variante": "Default Title",
      "shop_titel": "Kostal PLENTICOIN Universalgutschein für Funktionsfreischaltungen"
    },
    {
      "typ": "speicher",
      "familie": "alphaess-smile-g3-bat-3.8s",
      "schluessel": "3.6",
      "preis_cents": 109220,
      "verfuegbar": true,
      "handle": "alpha-ess-storion-batteriespeicher-smile-g3-bat-3-8s-3-65-kwh",
      "variante_id": 60346192134478,
      "shop_variante": "Default Title",
      "shop_titel": "Alpha ESS Storion Batteriespeicher, 3,65 kWh Kapazität, SMILE-G3-BAT-3.8S"
    },
    {
      "typ": "speicher",
      "familie": "alphaess-smile-g3-bat-9.3s",
      "schluessel": "9.3",
      "preis_cents": 290000,
      "verfuegbar": true,
      "handle": "alpha-ess-storion-batteriespeicher-9-3-kwh-kapazitat-smile-g3-bat-9-3s",
      "variante_id": 55177872245070,
      "shop_variante": "Default Title",
      "shop_titel": "Alpha ESS Storion Batteriespeicher, 9,3 kWh Kapazität, SMILE-G3-BAT-9.3S"
    },
    {
      "typ": "speicher",
      "familie": "alphaess-smile-hi5-bat-4.8",
      "schluessel": "4.8",
      "preis_cents": 279895,
      "verfuegbar": false,
      "handle": "alpha-ess-batteriespeicher-smile-hi5-bat-4-8-kwh",
      "variante_id": 46997468545358,
      "shop_variante": "Default Title",
      "shop_titel": "AlphaESS Batteriespeicher, Smile-Hi5 mit 4,8 kWh Kapazität"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvb",
      "schluessel": "8.9",
      "preis_cents": 287066,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvb-hochvoltspeicher-5-9-29-6-kwh",
      "variante_id": 59287813161294,
      "shop_variante": "HVB 8.91 kWh",
      "shop_titel": "BYD Battery-Box HVB 5,9-29,6 Hochvoltspeicher Komplettspeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvb",
      "schluessel": "11.8",
      "preis_cents": 370043,
      "verfuegbar": false,
      "handle": "byd-battery-box-hvb-hochvoltspeicher-5-9-29-6-kwh",
      "variante_id": 59287813194062,
      "shop_variante": "HVB 11.88 kWh",
      "shop_titel": "BYD Battery-Box HVB 5,9-29,6 Hochvoltspeicher Komplettspeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvb",
      "schluessel": "14.8",
      "preis_cents": 453021,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvb-hochvoltspeicher-5-9-29-6-kwh",
      "variante_id": 59287813226830,
      "shop_variante": "HVB 14.8 kWh",
      "shop_titel": "BYD Battery-Box HVB 5,9-29,6 Hochvoltspeicher Komplettspeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvb",
      "schluessel": "17.8",
      "preis_cents": 597863,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvb-hochvoltspeicher-5-9-29-6-kwh",
      "variante_id": 59287813259598,
      "shop_variante": "HVB 17.82 kWh",
      "shop_titel": "BYD Battery-Box HVB 5,9-29,6 Hochvoltspeicher Komplettspeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvb",
      "schluessel": "20.7",
      "preis_cents": 690419,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvb-hochvoltspeicher-5-9-29-6-kwh",
      "variante_id": 59287813292366,
      "shop_variante": "HVB 20.79 kWh",
      "shop_titel": "BYD Battery-Box HVB 5,9-29,6 Hochvoltspeicher Komplettspeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvb",
      "schluessel": "23.7",
      "preis_cents": 702215,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvb-hochvoltspeicher-5-9-29-6-kwh",
      "variante_id": 59288241570126,
      "shop_variante": "HVB 23.76 kWh",
      "shop_titel": "BYD Battery-Box HVB 5,9-29,6 Hochvoltspeicher Komplettspeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvb",
      "schluessel": "26.7",
      "preis_cents": 786453,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvb-hochvoltspeicher-5-9-29-6-kwh",
      "variante_id": 59288248025422,
      "shop_variante": "HVB 26.72 kWh",
      "shop_titel": "BYD Battery-Box HVB 5,9-29,6 Hochvoltspeicher Komplettspeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvb",
      "schluessel": "29.6",
      "preis_cents": 1010173,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvb-hochvoltspeicher-5-9-29-6-kwh",
      "variante_id": 59288253989198,
      "shop_variante": "HVB 29.69 kWh",
      "shop_titel": "BYD Battery-Box HVB 5,9-29,6 Hochvoltspeicher Komplettspeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvm-plus",
      "schluessel": "8.3",
      "preis_cents": 251219,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvm-plus-batteriespeicher",
      "variante_id": 55202698068302,
      "shop_variante": "8.3 kWh (Komplettspeicher)",
      "shop_titel": "BYD Battery-Box HVM+ Batteriespeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvm-plus",
      "schluessel": "11.0",
      "preis_cents": 318155,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvm-plus-batteriespeicher",
      "variante_id": 55202698101070,
      "shop_variante": "11.0 kWh (Komplettspeicher)",
      "shop_titel": "BYD Battery-Box HVM+ Batteriespeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvm-plus",
      "schluessel": "13.8",
      "preis_cents": 393276,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvm-plus-batteriespeicher",
      "variante_id": 55202698133838,
      "shop_variante": "13.8 kWh (Komplettspeicher)",
      "shop_titel": "BYD Battery-Box HVM+ Batteriespeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvm-plus",
      "schluessel": "16.6",
      "preis_cents": 464305,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvm-plus-batteriespeicher",
      "variante_id": 55202698166606,
      "shop_variante": "16.6 kWh (Komplettspeicher)",
      "shop_titel": "BYD Battery-Box HVM+ Batteriespeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvm-plus",
      "schluessel": "19.3",
      "preis_cents": 535334,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvm-plus-batteriespeicher",
      "variante_id": 55202727100750,
      "shop_variante": "19.3 kWh (Komplettspeicher)",
      "shop_titel": "BYD Battery-Box HVM+ Batteriespeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvm-plus",
      "schluessel": "22.1",
      "preis_cents": 606363,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvm-plus-batteriespeicher",
      "variante_id": 55202727133518,
      "shop_variante": "22.1 kWh (Komplettspeicher)",
      "shop_titel": "BYD Battery-Box HVM+ Batteriespeicher"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvs-plus",
      "schluessel": "5.1",
      "preis_cents": 201067,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvs-plus-batteriespeicher",
      "variante_id": 55202605957454,
      "shop_variante": "5.12 kWh (Komplettspeicher)",
      "shop_titel": "BYD Battery-Box HVS+ Batteriespeicher, 5.1 bis 12.8 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvs-plus",
      "schluessel": "7.7",
      "preis_cents": 267518,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvs-plus-batteriespeicher",
      "variante_id": 55202605990222,
      "shop_variante": "7.7 kWh (Komplettspeicher)",
      "shop_titel": "BYD Battery-Box HVS+ Batteriespeicher, 5.1 bis 12.8 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvs-plus",
      "schluessel": "10.2",
      "preis_cents": 854,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvs-plus-batteriespeicher",
      "variante_id": 55202606022990,
      "shop_variante": "10.2 kWh (Komplettspeicher)",
      "shop_titel": "BYD Battery-Box HVS+ Batteriespeicher, 5.1 bis 12.8 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-hvs-plus",
      "schluessel": "12.8",
      "preis_cents": 392428,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvs-plus-batteriespeicher",
      "variante_id": 55202606055758,
      "shop_variante": "12.8 kWh (Komplettspeicher)",
      "shop_titel": "BYD Battery-Box HVS+ Batteriespeicher, 5.1 bis 12.8 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-hvm",
      "schluessel": "8.3",
      "preis_cents": 293165,
      "verfuegbar": true,
      "handle": "byd-hvm-2-76kwh",
      "variante_id": 47032602296654,
      "shop_variante": "8,3 kWh Kapazität",
      "shop_titel": "BYD Stromspeicher, Battery-Box Premium HVM, 8.28 - 22.08 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-hvm",
      "schluessel": "11.0",
      "preis_cents": 375654,
      "verfuegbar": true,
      "handle": "byd-hvm-2-76kwh",
      "variante_id": 47032602329422,
      "shop_variante": "11,0 kWh Kapazität",
      "shop_titel": "BYD Stromspeicher, Battery-Box Premium HVM, 8.28 - 22.08 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-hvm",
      "schluessel": "13.8",
      "preis_cents": 458144,
      "verfuegbar": true,
      "handle": "byd-hvm-2-76kwh",
      "variante_id": 47032602362190,
      "shop_variante": "13,8 kWh Kapazität",
      "shop_titel": "BYD Stromspeicher, Battery-Box Premium HVM, 8.28 - 22.08 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-hvm",
      "schluessel": "16.6",
      "preis_cents": 540634,
      "verfuegbar": true,
      "handle": "byd-hvm-2-76kwh",
      "variante_id": 47032602394958,
      "shop_variante": "16,6 kWh Kapazität",
      "shop_titel": "BYD Stromspeicher, Battery-Box Premium HVM, 8.28 - 22.08 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-hvm",
      "schluessel": "19.3",
      "preis_cents": 623123,
      "verfuegbar": true,
      "handle": "byd-hvm-2-76kwh",
      "variante_id": 47032602427726,
      "shop_variante": "19,3 kWh Kapazität",
      "shop_titel": "BYD Stromspeicher, Battery-Box Premium HVM, 8.28 - 22.08 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-hvm",
      "schluessel": "22.1",
      "preis_cents": 705613,
      "verfuegbar": true,
      "handle": "byd-hvm-2-76kwh",
      "variante_id": 47032602460494,
      "shop_variante": "22,1 kWh Kapazität",
      "shop_titel": "BYD Stromspeicher, Battery-Box Premium HVM, 8.28 - 22.08 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-hvs",
      "schluessel": "5.1",
      "preis_cents": 177070,
      "verfuegbar": true,
      "handle": "byd-hvs-10-2",
      "variante_id": 47031940514126,
      "shop_variante": "5,1 kWh Kapazität",
      "shop_titel": "BYD B-BOX PREMIUM HVS Batteriespeicher, 5.12 - 12,8 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-hvs",
      "schluessel": "7.7",
      "preis_cents": 239765,
      "verfuegbar": true,
      "handle": "byd-hvs-10-2",
      "variante_id": 47031940546894,
      "shop_variante": "7,7 kWh Kapazität",
      "shop_titel": "BYD B-BOX PREMIUM HVS Batteriespeicher, 5.12 - 12,8 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-hvs",
      "schluessel": "10.2",
      "preis_cents": 307460,
      "verfuegbar": true,
      "handle": "byd-hvs-10-2",
      "variante_id": 47031940579662,
      "shop_variante": "10,2 kWh Kapazität",
      "shop_titel": "BYD B-BOX PREMIUM HVS Batteriespeicher, 5.12 - 12,8 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-hvs",
      "schluessel": "12.8",
      "preis_cents": 375765,
      "verfuegbar": true,
      "handle": "byd-hvs-10-2",
      "variante_id": 47031940612430,
      "shop_variante": "12,8 kWh Kapazität",
      "shop_titel": "BYD B-BOX PREMIUM HVS Batteriespeicher, 5.12 - 12,8 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-lvs",
      "schluessel": "4.0",
      "preis_cents": 144343,
      "verfuegbar": true,
      "handle": "byd-battery-box-premium-lvs-flexibler-niedervolt-speicher-von-4-kwh-bis-24-kwh",
      "variante_id": 55144201486670,
      "shop_variante": "4 kWh Gesamtspeicher",
      "shop_titel": "BYD Battery-Box Premium LVS – Flexibler Niedervolt-Speicher von 4 kWh bis 24 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-lvs",
      "schluessel": "8.0",
      "preis_cents": 243442,
      "verfuegbar": true,
      "handle": "byd-battery-box-premium-lvs-flexibler-niedervolt-speicher-von-4-kwh-bis-24-kwh",
      "variante_id": 55144201519438,
      "shop_variante": "8 kWh Gesamtspeicher",
      "shop_titel": "BYD Battery-Box Premium LVS – Flexibler Niedervolt-Speicher von 4 kWh bis 24 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-lvs",
      "schluessel": "12.0",
      "preis_cents": 301700,
      "verfuegbar": true,
      "handle": "byd-battery-box-premium-lvs-flexibler-niedervolt-speicher-von-4-kwh-bis-24-kwh",
      "variante_id": 55144201552206,
      "shop_variante": "12 kWh Gesamtspeicher",
      "shop_titel": "BYD Battery-Box Premium LVS – Flexibler Niedervolt-Speicher von 4 kWh bis 24 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-lvs",
      "schluessel": "16.0",
      "preis_cents": 402090,
      "verfuegbar": true,
      "handle": "byd-battery-box-premium-lvs-flexibler-niedervolt-speicher-von-4-kwh-bis-24-kwh",
      "variante_id": 55144201584974,
      "shop_variante": "16 kWh Gesamtspeicher",
      "shop_titel": "BYD Battery-Box Premium LVS – Flexibler Niedervolt-Speicher von 4 kWh bis 24 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-lvs",
      "schluessel": "20.0",
      "preis_cents": 507877,
      "verfuegbar": true,
      "handle": "byd-battery-box-premium-lvs-flexibler-niedervolt-speicher-von-4-kwh-bis-24-kwh",
      "variante_id": 55144201617742,
      "shop_variante": "20 kWh Gesamtspeicher",
      "shop_titel": "BYD Battery-Box Premium LVS – Flexibler Niedervolt-Speicher von 4 kWh bis 24 kWh"
    },
    {
      "typ": "speicher",
      "familie": "byd-premium-lvs",
      "schluessel": "24.0",
      "preis_cents": 582090,
      "verfuegbar": true,
      "handle": "byd-battery-box-premium-lvs-flexibler-niedervolt-speicher-von-4-kwh-bis-24-kwh",
      "variante_id": 55144201650510,
      "shop_variante": "24 kWh Gesamtspeicher",
      "shop_titel": "BYD Battery-Box Premium LVS – Flexibler Niedervolt-Speicher von 4 kWh bis 24 kWh"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "3S",
      "preis_cents": 261874,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609410666830,
      "shop_variante": "Dyness Stack 100 - 15,36kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "4S",
      "preis_cents": 334060,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609410699598,
      "shop_variante": "Dyness Stack 100 - 20,48kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "5S",
      "preis_cents": 403560,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609410732366,
      "shop_variante": "Dyness Stack 100 - 25,60kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "6S",
      "preis_cents": 472460,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609410765134,
      "shop_variante": "Dyness Stack 100 - 30,72kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "7S",
      "preis_cents": 526360,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609410797902,
      "shop_variante": "Dyness Stack 100 - 35,84kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "8S",
      "preis_cents": 603210,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609689391438,
      "shop_variante": "Dyness Stack 100 - 40,96kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "9S",
      "preis_cents": 662060,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609715441998,
      "shop_variante": "Dyness Stack 100 - 46,08kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "10S",
      "preis_cents": 723660,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609725600078,
      "shop_variante": "Dyness Stack 100 - 51,20kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "11S",
      "preis_cents": 840420,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609750241614,
      "shop_variante": "Dyness Stack 100 - 56,32kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "12S",
      "preis_cents": 948480,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609783632206,
      "shop_variante": "Dyness Stack 100 - 61,44kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "13S",
      "preis_cents": 1020000,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609786941774,
      "shop_variante": "Dyness Stack 100 - 66,56kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "14S",
      "preis_cents": 1091520,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609790677326,
      "shop_variante": "Dyness Stack 100 - 71,68kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-stack100",
      "schluessel": "15S",
      "preis_cents": 1163040,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59609813025102,
      "shop_variante": "Dyness Stack 100 - 76,80kWh",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-pro",
      "schluessel": "TP7",
      "preis_cents": 162750,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-2-0-set-tower-pro-1",
      "variante_id": 59124645200206,
      "shop_variante": "TP7 (7.68 kWh)",
      "shop_titel": "Dyness Batteriespeicher Set Tower Pro"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-pro",
      "schluessel": "TP11",
      "preis_cents": 215265,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-2-0-set-tower-pro-1",
      "variante_id": 59124645232974,
      "shop_variante": "TP11 (11.52 kWh)",
      "shop_titel": "Dyness Batteriespeicher Set Tower Pro"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-pro",
      "schluessel": "TP15",
      "preis_cents": 271475,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-2-0-set-tower-pro-1",
      "variante_id": 59124645265742,
      "shop_variante": "TP15 (15.36 kWh)",
      "shop_titel": "Dyness Batteriespeicher Set Tower Pro"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-pro",
      "schluessel": "TP19",
      "preis_cents": 340460,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-2-0-set-tower-pro-1",
      "variante_id": 59124645298510,
      "shop_variante": "TP19 (19.20 kWh)",
      "shop_titel": "Dyness Batteriespeicher Set Tower Pro"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-pro",
      "schluessel": "TP23",
      "preis_cents": 399155,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-2-0-set-tower-pro-1",
      "variante_id": 59124645331278,
      "shop_variante": "TP23 (23.04 kWh)",
      "shop_titel": "Dyness Batteriespeicher Set Tower Pro"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-s2",
      "schluessel": "T7",
      "preis_cents": 130000,
      "verfuegbar": false,
      "handle": "dyness-tower-hochvolt-batteriespeicher-s2-7-1-21-3-kwh",
      "variante_id": 60243067076942,
      "shop_variante": "Tower T7, 7,1 kWh",
      "shop_titel": "Dyness Tower Hochvolt-Batteriespeicher S2 (7,1 - 21,3 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-s2",
      "schluessel": "T10",
      "preis_cents": 180000,
      "verfuegbar": false,
      "handle": "dyness-tower-hochvolt-batteriespeicher-s2-7-1-21-3-kwh",
      "variante_id": 60243067109710,
      "shop_variante": "Tower T10, 10,66 kWh",
      "shop_titel": "Dyness Tower Hochvolt-Batteriespeicher S2 (7,1 - 21,3 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-s2",
      "schluessel": "T14",
      "preis_cents": 234000,
      "verfuegbar": false,
      "handle": "dyness-tower-hochvolt-batteriespeicher-s2-7-1-21-3-kwh",
      "variante_id": 60243067142478,
      "shop_variante": "Tower T14, 14,21 kWh",
      "shop_titel": "Dyness Tower Hochvolt-Batteriespeicher S2 (7,1 - 21,3 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-s2",
      "schluessel": "T17",
      "preis_cents": 295000,
      "verfuegbar": false,
      "handle": "dyness-tower-hochvolt-batteriespeicher-s2-7-1-21-3-kwh",
      "variante_id": 60243067175246,
      "shop_variante": "Tower T17, 17,76 kWh",
      "shop_titel": "Dyness Tower Hochvolt-Batteriespeicher S2 (7,1 - 21,3 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-s2",
      "schluessel": "T21",
      "preis_cents": 345000,
      "verfuegbar": false,
      "handle": "dyness-tower-hochvolt-batteriespeicher-s2-7-1-21-3-kwh",
      "variante_id": 60243067208014,
      "shop_variante": "Tower T21, 21,31 kWh",
      "shop_titel": "Dyness Tower Hochvolt-Batteriespeicher S2 (7,1 - 21,3 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-s3",
      "schluessel": "TS7",
      "preis_cents": 158055,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-set-tower-3-0",
      "variante_id": 55447396155726,
      "shop_variante": "TS7 (7.1 kWh)",
      "shop_titel": "Dyness Batteriespeicher Set Tower S3 TS3"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-s3",
      "schluessel": "TS10",
      "preis_cents": 187500,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-set-tower-3-0",
      "variante_id": 55447396188494,
      "shop_variante": "TS10 (10.66 kWh)",
      "shop_titel": "Dyness Batteriespeicher Set Tower S3 TS3"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-s3",
      "schluessel": "TS14",
      "preis_cents": 264060,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-set-tower-3-0",
      "variante_id": 55447396221262,
      "shop_variante": "TS14 (14.21 kWh)",
      "shop_titel": "Dyness Batteriespeicher Set Tower S3 TS3"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-s3",
      "schluessel": "TS17",
      "preis_cents": 321699,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-set-tower-3-0",
      "variante_id": 55447396254030,
      "shop_variante": "TS17 (17.76 kWh)",
      "shop_titel": "Dyness Batteriespeicher Set Tower S3 TS3"
    },
    {
      "typ": "speicher",
      "familie": "dyness-tower-s3",
      "schluessel": "TS21",
      "preis_cents": 371699,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-set-tower-3-0",
      "variante_id": 55447396286798,
      "shop_variante": "TS21 (21.31 kWh)",
      "shop_titel": "Dyness Batteriespeicher Set Tower S3 TS3"
    },
    {
      "typ": "speicher",
      "familie": "fronius-reserva-pro",
      "schluessel": "12.0",
      "preis_cents": 475200,
      "verfuegbar": true,
      "handle": "fronius-reserva-pro-hochleistungs-hv-speicher",
      "variante_id": 59362410692942,
      "shop_variante": "12.0 (11,9 kWh Gesamtspeicher)",
      "shop_titel": "Fronius Reserva Pro | Hochleistungs-HV-Speicher"
    },
    {
      "typ": "speicher",
      "familie": "fronius-reserva-pro",
      "schluessel": "16.0",
      "preis_cents": 601700,
      "verfuegbar": true,
      "handle": "fronius-reserva-pro-hochleistungs-hv-speicher",
      "variante_id": 59362410725710,
      "shop_variante": "16.0 (15,9 kWh Gesamtspeicher)",
      "shop_titel": "Fronius Reserva Pro | Hochleistungs-HV-Speicher"
    },
    {
      "typ": "speicher",
      "familie": "fronius-reserva-pro",
      "schluessel": "20.0",
      "preis_cents": 727600,
      "verfuegbar": true,
      "handle": "fronius-reserva-pro-hochleistungs-hv-speicher",
      "variante_id": 59362410758478,
      "shop_variante": "20.0 (19,9 kWh Gesamtspeicher)",
      "shop_titel": "Fronius Reserva Pro | Hochleistungs-HV-Speicher"
    },
    {
      "typ": "speicher",
      "familie": "fronius-reserva-pro",
      "schluessel": "24.0",
      "preis_cents": 854200,
      "verfuegbar": true,
      "handle": "fronius-reserva-pro-hochleistungs-hv-speicher",
      "variante_id": 59362410791246,
      "shop_variante": "24.0 (23,9 kWh Gesamtspeicher)",
      "shop_titel": "Fronius Reserva Pro | Hochleistungs-HV-Speicher"
    },
    {
      "typ": "speicher",
      "familie": "fronius-reserva-pro",
      "schluessel": "28.0",
      "preis_cents": 967800,
      "verfuegbar": true,
      "handle": "fronius-reserva-pro-hochleistungs-hv-speicher",
      "variante_id": 59362410824014,
      "shop_variante": "28.0 (27,9 kWh Gesamtspeicher)",
      "shop_titel": "Fronius Reserva Pro | Hochleistungs-HV-Speicher"
    },
    {
      "typ": "speicher",
      "familie": "fronius-reserva-pro",
      "schluessel": "32.0",
      "preis_cents": 1092600,
      "verfuegbar": true,
      "handle": "fronius-reserva-pro-hochleistungs-hv-speicher",
      "variante_id": 59362410856782,
      "shop_variante": "32.0 (31,9 kWh Gesamtspeicher)",
      "shop_titel": "Fronius Reserva Pro | Hochleistungs-HV-Speicher"
    },
    {
      "typ": "speicher",
      "familie": "growatt-apx",
      "schluessel": "APX 5.0P",
      "preis_cents": 132092,
      "verfuegbar": true,
      "handle": "growatt-hochvolt-batteriesystem-apx-hv-series-speicher-fur-mod-xhbp-und-mid-xh-wechselrichter",
      "variante_id": 59257052037454,
      "shop_variante": "APX5.0P mit 5 kWh Gesamtspeicher",
      "shop_titel": "Growatt APX Hochvolt Speicher 5.0P-30.0P für MOD-XH(BP) und MID-XH Wechselrichter"
    },
    {
      "typ": "speicher",
      "familie": "growatt-apx",
      "schluessel": "APX 10.0P",
      "preis_cents": 205600,
      "verfuegbar": true,
      "handle": "growatt-hochvolt-batteriesystem-apx-hv-series-speicher-fur-mod-xhbp-und-mid-xh-wechselrichter",
      "variante_id": 59257052070222,
      "shop_variante": "APX10.0P mit 10 kWh Gesamtspeicher",
      "shop_titel": "Growatt APX Hochvolt Speicher 5.0P-30.0P für MOD-XH(BP) und MID-XH Wechselrichter"
    },
    {
      "typ": "speicher",
      "familie": "growatt-apx",
      "schluessel": "APX 15.0P",
      "preis_cents": 301580,
      "verfuegbar": true,
      "handle": "growatt-hochvolt-batteriesystem-apx-hv-series-speicher-fur-mod-xhbp-und-mid-xh-wechselrichter",
      "variante_id": 59257052102990,
      "shop_variante": "APX15.0P mit 15 kWh Gesamtspeicher",
      "shop_titel": "Growatt APX Hochvolt Speicher 5.0P-30.0P für MOD-XH(BP) und MID-XH Wechselrichter"
    },
    {
      "typ": "speicher",
      "familie": "growatt-apx",
      "schluessel": "APX 20.0P",
      "preis_cents": 398700,
      "verfuegbar": true,
      "handle": "growatt-hochvolt-batteriesystem-apx-hv-series-speicher-fur-mod-xhbp-und-mid-xh-wechselrichter",
      "variante_id": 59257052135758,
      "shop_variante": "APX20.0P mit 20 kWh Gesamtspeicher",
      "shop_titel": "Growatt APX Hochvolt Speicher 5.0P-30.0P für MOD-XH(BP) und MID-XH Wechselrichter"
    },
    {
      "typ": "speicher",
      "familie": "growatt-apx",
      "schluessel": "APX 25.0P",
      "preis_cents": 551553,
      "verfuegbar": false,
      "handle": "growatt-hochvolt-batteriesystem-apx-hv-series-speicher-fur-mod-xhbp-und-mid-xh-wechselrichter",
      "variante_id": 59257052168526,
      "shop_variante": "APX25.0P mit 25 kWh Gesamtspeicher",
      "shop_titel": "Growatt APX Hochvolt Speicher 5.0P-30.0P für MOD-XH(BP) und MID-XH Wechselrichter"
    },
    {
      "typ": "speicher",
      "familie": "growatt-apx",
      "schluessel": "APX 30.0P",
      "preis_cents": 650399,
      "verfuegbar": false,
      "handle": "growatt-hochvolt-batteriesystem-apx-hv-series-speicher-fur-mod-xhbp-und-mid-xh-wechselrichter",
      "variante_id": 59257052201294,
      "shop_variante": "APX30.0P mit 30 kWh Gesamtspeicher",
      "shop_titel": "Growatt APX Hochvolt Speicher 5.0P-30.0P für MOD-XH(BP) und MID-XH Wechselrichter"
    },
    {
      "typ": "speicher",
      "familie": "huawei-luna2000-s0",
      "schluessel": "5",
      "preis_cents": 194480,
      "verfuegbar": true,
      "handle": "huawei-luna2000-5-10-15-s0",
      "variante_id": 60765499490638,
      "shop_variante": "LUNA2000-5-S0",
      "shop_titel": "Huawei LUNA2000-5/10/15-S0 Stromspeicher | Hochvolt-System"
    },
    {
      "typ": "speicher",
      "familie": "huawei-luna2000-s0",
      "schluessel": "10",
      "preis_cents": 347190,
      "verfuegbar": true,
      "handle": "huawei-luna2000-5-10-15-s0",
      "variante_id": 60765499425102,
      "shop_variante": "LUNA2000-10-S0",
      "shop_titel": "Huawei LUNA2000-5/10/15-S0 Stromspeicher | Hochvolt-System"
    },
    {
      "typ": "speicher",
      "familie": "huawei-luna2000-s0",
      "schluessel": "15",
      "preis_cents": 532440,
      "verfuegbar": true,
      "handle": "huawei-luna2000-5-10-15-s0",
      "variante_id": 60765499457870,
      "shop_variante": "LUNA2000-15-S0",
      "shop_titel": "Huawei LUNA2000-5/10/15-S0 Stromspeicher | Hochvolt-System"
    },
    {
      "typ": "speicher",
      "familie": "huawei-luna2000-s1",
      "schluessel": "7",
      "preis_cents": 318248,
      "verfuegbar": true,
      "handle": "huawei-batteriespeicher-luna2000-s1",
      "variante_id": 48522642850126,
      "shop_variante": "7 kWh / LUNA2000-7-S1",
      "shop_titel": "Huawei Batteriespeicher LUNA2000-S1"
    },
    {
      "typ": "speicher",
      "familie": "huawei-luna2000-s1",
      "schluessel": "14",
      "preis_cents": 476888,
      "verfuegbar": true,
      "handle": "huawei-batteriespeicher-luna2000-s1",
      "variante_id": 59990262710606,
      "shop_variante": "14 kWh / LUNA2000-14-S1",
      "shop_titel": "Huawei Batteriespeicher LUNA2000-S1"
    },
    {
      "typ": "speicher",
      "familie": "huawei-luna2000-s1",
      "schluessel": "21",
      "preis_cents": 688241,
      "verfuegbar": true,
      "handle": "huawei-batteriespeicher-luna2000-s1",
      "variante_id": 59990266315086,
      "shop_variante": "21 kWh / LUNA2000-21-S1",
      "shop_titel": "Huawei Batteriespeicher LUNA2000-S1"
    },
    {
      "typ": "speicher",
      "familie": "solaredge-home-batterie-400v",
      "schluessel": "9.7",
      "preis_cents": 392080,
      "verfuegbar": true,
      "handle": "solaredge-batteriesystem-10-kwh-hochvolt-lithium-ionen-9-7-kwh-netto-5-kw-leistung-ip55-350-450-vdc",
      "variante_id": 52862705729870,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge Batteriesystem 10 kWh Hochvolt Lithium-Ionen, 9,7 kWh netto, 5 kW Leistung, IP55, 350-450 Vdc"
    },
    {
      "typ": "speicher",
      "familie": "solaredge-home-batterie-48v",
      "schluessel": "4.6",
      "preis_cents": 179509,
      "verfuegbar": false,
      "handle": "solaredge-home-batterie-48v-modularer-speicher-4-6-23-kwh-1",
      "variante_id": 60022523003214,
      "shop_variante": "SolarEdge Home Battery-02 3ph/48V 4,6/4,85kWh",
      "shop_titel": "SolarEdge Home Batterie 48V | Modularer Speicher 4,6 - 23 kWh"
    },
    {
      "typ": "speicher",
      "familie": "solaredge-home-batterie-48v",
      "schluessel": "9.2",
      "preis_cents": 343072,
      "verfuegbar": false,
      "handle": "solaredge-home-batterie-48v-modularer-speicher-4-6-23-kwh-1",
      "variante_id": 60022523035982,
      "shop_variante": "SolarEdge Home Battery-02 3ph/48V 9,2/9,7kWh",
      "shop_titel": "SolarEdge Home Batterie 48V | Modularer Speicher 4,6 - 23 kWh"
    },
    {
      "typ": "speicher",
      "familie": "solaredge-home-batterie-48v",
      "schluessel": "13.8",
      "preis_cents": 505222,
      "verfuegbar": false,
      "handle": "solaredge-home-batterie-48v-modularer-speicher-4-6-23-kwh-1",
      "variante_id": 60022523068750,
      "shop_variante": "SolarEdge Home Battery-02 3ph/48V 13,8/14,55kWh",
      "shop_titel": "SolarEdge Home Batterie 48V | Modularer Speicher 4,6 - 23 kWh"
    },
    {
      "typ": "speicher",
      "familie": "solaredge-home-batterie-48v",
      "schluessel": "18.4",
      "preis_cents": 682766,
      "verfuegbar": false,
      "handle": "solaredge-home-batterie-48v-modularer-speicher-4-6-23-kwh-1",
      "variante_id": 60022523101518,
      "shop_variante": "SolarEdge Home Battery-02 3ph/48V 18,4/19,4kWh",
      "shop_titel": "SolarEdge Home Batterie 48V | Modularer Speicher 4,6 - 23 kWh"
    },
    {
      "typ": "speicher",
      "familie": "solaredge-home-batterie-48v",
      "schluessel": "23.0",
      "preis_cents": 849283,
      "verfuegbar": false,
      "handle": "solaredge-home-batterie-48v-modularer-speicher-4-6-23-kwh-1",
      "variante_id": 60022523134286,
      "shop_variante": "SolarEdge Home Battery-02 3ph/48V 23/24,25kWh",
      "shop_titel": "SolarEdge Home Batterie 48V | Modularer Speicher 4,6 - 23 kWh"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbh",
      "schluessel": "SBH100",
      "preis_cents": 299106,
      "verfuegbar": true,
      "handle": "sungrow-sbh-batteriespeicher-sbh100-150-200-250-300-350-400",
      "variante_id": 59492119085390,
      "shop_variante": "SBH100, 10 kWh",
      "shop_titel": "Sungrow SBH100/150/200/250/300/350/400 modularer Hochvolt-Batteriespeicher (10–40 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbh",
      "schluessel": "SBH150",
      "preis_cents": 433200,
      "verfuegbar": true,
      "handle": "sungrow-sbh-batteriespeicher-sbh100-150-200-250-300-350-400",
      "variante_id": 59492119118158,
      "shop_variante": "SBH150, 15 kWh",
      "shop_titel": "Sungrow SBH100/150/200/250/300/350/400 modularer Hochvolt-Batteriespeicher (10–40 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbh",
      "schluessel": "SBH200",
      "preis_cents": 564900,
      "verfuegbar": true,
      "handle": "sungrow-sbh-batteriespeicher-sbh100-150-200-250-300-350-400",
      "variante_id": 59492119150926,
      "shop_variante": "SBH200, 20 kWh",
      "shop_titel": "Sungrow SBH100/150/200/250/300/350/400 modularer Hochvolt-Batteriespeicher (10–40 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbh",
      "schluessel": "SBH250",
      "preis_cents": 692900,
      "verfuegbar": true,
      "handle": "sungrow-sbh-batteriespeicher-sbh100-150-200-250-300-350-400",
      "variante_id": 59492119183694,
      "shop_variante": "SBH250, 25 kWh",
      "shop_titel": "Sungrow SBH100/150/200/250/300/350/400 modularer Hochvolt-Batteriespeicher (10–40 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbh",
      "schluessel": "SBH300",
      "preis_cents": 793200,
      "verfuegbar": true,
      "handle": "sungrow-sbh-batteriespeicher-sbh100-150-200-250-300-350-400",
      "variante_id": 59492119216462,
      "shop_variante": "SBH300, 30 kWh",
      "shop_titel": "Sungrow SBH100/150/200/250/300/350/400 modularer Hochvolt-Batteriespeicher (10–40 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbh",
      "schluessel": "SBH350",
      "preis_cents": 913800,
      "verfuegbar": true,
      "handle": "sungrow-sbh-batteriespeicher-sbh100-150-200-250-300-350-400",
      "variante_id": 59492119249230,
      "shop_variante": "SBH350, 35 kWh",
      "shop_titel": "Sungrow SBH100/150/200/250/300/350/400 modularer Hochvolt-Batteriespeicher (10–40 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbh",
      "schluessel": "SBH400",
      "preis_cents": 1040800,
      "verfuegbar": true,
      "handle": "sungrow-sbh-batteriespeicher-sbh100-150-200-250-300-350-400",
      "variante_id": 59492119281998,
      "shop_variante": "SBH400, 40 kWh",
      "shop_titel": "Sungrow SBH100/150/200/250/300/350/400 modularer Hochvolt-Batteriespeicher (10–40 kWh)"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbr",
      "schluessel": "SBR096",
      "preis_cents": 345000,
      "verfuegbar": true,
      "handle": "sungrow-sbr-hochspannungs-lfp-batterieserie",
      "variante_id": 59718909493582,
      "shop_variante": "Sungrow SBR096",
      "shop_titel": "Sungrow SBR Hochspannungs-LFP-Batterieserie SBR064-SBR256"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbr",
      "schluessel": "SBR128",
      "preis_cents": 433840,
      "verfuegbar": true,
      "handle": "sungrow-sbr-hochspannungs-lfp-batterieserie",
      "variante_id": 59718909526350,
      "shop_variante": "Sungrow SBR128",
      "shop_titel": "Sungrow SBR Hochspannungs-LFP-Batterieserie SBR064-SBR256"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbr",
      "schluessel": "SBR160",
      "preis_cents": 533600,
      "verfuegbar": true,
      "handle": "sungrow-sbr-hochspannungs-lfp-batterieserie",
      "variante_id": 59718909559118,
      "shop_variante": "Sungrow SBR160",
      "shop_titel": "Sungrow SBR Hochspannungs-LFP-Batterieserie SBR064-SBR256"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbr",
      "schluessel": "SBR192",
      "preis_cents": 627900,
      "verfuegbar": true,
      "handle": "sungrow-sbr-hochspannungs-lfp-batterieserie",
      "variante_id": 59718909591886,
      "shop_variante": "Sungrow SBR192",
      "shop_titel": "Sungrow SBR Hochspannungs-LFP-Batterieserie SBR064-SBR256"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbr",
      "schluessel": "SBR224",
      "preis_cents": 726800,
      "verfuegbar": true,
      "handle": "sungrow-sbr-hochspannungs-lfp-batterieserie",
      "variante_id": 59718909624654,
      "shop_variante": "Sungrow SBR224",
      "shop_titel": "Sungrow SBR Hochspannungs-LFP-Batterieserie SBR064-SBR256"
    },
    {
      "typ": "speicher",
      "familie": "sungrow-sbr",
      "schluessel": "SBR256",
      "preis_cents": 825700,
      "verfuegbar": true,
      "handle": "sungrow-sbr-hochspannungs-lfp-batterieserie",
      "variante_id": 59718909657422,
      "shop_variante": "Sungrow SBR256",
      "shop_titel": "Sungrow SBR Hochspannungs-LFP-Batterieserie SBR064-SBR256"
    },
    {
      "typ": "modul",
      "familie": "byd-hvb",
      "schluessel": "modul",
      "preis_cents": 102213,
      "verfuegbar": false,
      "handle": "byd-battery-box-hvb-hochvoltspeicher-5-9-29-6-kwh",
      "variante_id": 59388301312334,
      "shop_variante": "HVB Batterieerweiterung 2,97 kWh (Einzelnes Speichermodul)",
      "shop_titel": "BYD Battery-Box HVB 5,9-29,6 Hochvoltspeicher Komplettspeicher"
    },
    {
      "typ": "modul",
      "familie": "byd-hvm-plus",
      "schluessel": "modul",
      "preis_cents": 74405,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvm-plus-batteriespeicher",
      "variante_id": 55202698035534,
      "shop_variante": "2.76 kWh (Nur Speichermodul)",
      "shop_titel": "BYD Battery-Box HVM+ Batteriespeicher"
    },
    {
      "typ": "modul",
      "familie": "byd-hvs-plus",
      "schluessel": "modul",
      "preis_cents": 82323,
      "verfuegbar": true,
      "handle": "byd-battery-box-hvs-plus-batteriespeicher",
      "variante_id": 55202605924686,
      "shop_variante": "2.56 kWh (Nur Speichermodul)",
      "shop_titel": "BYD Battery-Box HVS+ Batteriespeicher, 5.1 bis 12.8 kWh"
    },
    {
      "typ": "modul",
      "familie": "byd-premium-hvm",
      "schluessel": "modul",
      "preis_cents": 90670,
      "verfuegbar": false,
      "handle": "byd-hvm-2-76kwh",
      "variante_id": 50826375168334,
      "shop_variante": "2,76 kWh Erweiterungsmodul",
      "shop_titel": "BYD Stromspeicher, Battery-Box Premium HVM, 8.28 - 22.08 kWh"
    },
    {
      "typ": "modul",
      "familie": "byd-premium-hvs",
      "schluessel": "modul",
      "preis_cents": 76750,
      "verfuegbar": true,
      "handle": "byd-hvs-10-2",
      "variante_id": 47086456930638,
      "shop_variante": "2,56 kWh Kapazität (Einzelmodul)",
      "shop_titel": "BYD B-BOX PREMIUM HVS Batteriespeicher, 5.12 - 12,8 kWh"
    },
    {
      "typ": "modul",
      "familie": "byd-premium-lvs",
      "schluessel": "modul",
      "preis_cents": 106680,
      "verfuegbar": false,
      "handle": "byd-battery-box-premium-lvs-flexibler-niedervolt-speicher-von-4-kwh-bis-24-kwh",
      "variante_id": 55144201453902,
      "shop_variante": "4 kWh (Speichermodul)",
      "shop_titel": "BYD Battery-Box Premium LVS – Flexibler Niedervolt-Speicher von 4 kWh bis 24 kWh"
    },
    {
      "typ": "modul",
      "familie": "dyness-stack100",
      "schluessel": "modul",
      "preis_cents": 68659,
      "verfuegbar": true,
      "handle": "dyness-stack-100-die-perfekte-hochvolt-losung-fur-gewerbe-und-grosse-pv-anlagen",
      "variante_id": 59711229395278,
      "shop_variante": "5.12 kWh (Nur Speichermodul)",
      "shop_titel": "Dyness Stack 100 15,36–76,80 kWh | All-In-One ESS & Energiespeicher"
    },
    {
      "typ": "modul",
      "familie": "dyness-tower-pro",
      "schluessel": "modul",
      "preis_cents": 68710,
      "verfuegbar": true,
      "handle": "dyness-batteriespeicher-2-0-set-tower-pro-1",
      "variante_id": 59274078552398,
      "shop_variante": "3.84 (Nur Speichermodul)",
      "shop_titel": "Dyness Batteriespeicher Set Tower Pro"
    },
    {
      "typ": "modul",
      "familie": "dyness-tower-s2",
      "schluessel": "modul",
      "preis_cents": 59880,
      "verfuegbar": true,
      "handle": "dyness-tower-hochvolt-batteriespeicher-s2-7-1-21-3-kwh",
      "variante_id": 60243067240782,
      "shop_variante": "Dyness Tower 3,55 kWh (Nur Speicherblock, HV9637)",
      "shop_titel": "Dyness Tower Hochvolt-Batteriespeicher S2 (7,1 - 21,3 kWh)"
    },
    {
      "typ": "modul",
      "familie": "dyness-tower-s3",
      "schluessel": "modul",
      "preis_cents": 54600,
      "verfuegbar": false,
      "handle": "dyness-batteriespeicher-set-tower-3-0",
      "variante_id": 59497017180494,
      "shop_variante": "Dyness Tower S3 3,55 kWh (Nur Speicherblock, HV9637S)",
      "shop_titel": "Dyness Batteriespeicher Set Tower S3 TS3"
    },
    {
      "typ": "modul",
      "familie": "fronius-reserva-pro",
      "schluessel": "modul",
      "preis_cents": 147115,
      "verfuegbar": true,
      "handle": "fronius-reserva-pro-hochleistungs-hv-speicher",
      "variante_id": 59763525484878,
      "shop_variante": "3,98 kWh (Nur Speichermodul)",
      "shop_titel": "Fronius Reserva Pro | Hochleistungs-HV-Speicher"
    },
    {
      "typ": "modul",
      "familie": "huawei-luna2000-s0",
      "schluessel": "modul",
      "preis_cents": 174900,
      "verfuegbar": true,
      "handle": "huawei-luna2000-5-10-15-s0",
      "variante_id": 60765499523406,
      "shop_variante": "LUNA2000-5-E0 (Nur 5 kWh Speichermodul)",
      "shop_titel": "Huawei LUNA2000-5/10/15-S0 Stromspeicher | Hochvolt-System"
    },
    {
      "typ": "modul",
      "familie": "huawei-luna2000-s1",
      "schluessel": "modul",
      "preis_cents": 215524,
      "verfuegbar": false,
      "handle": "huawei-batteriespeicher-luna2000-s1",
      "variante_id": 59990266380622,
      "shop_variante": "7 kWh / Nur Erweiterungsmodul",
      "shop_titel": "Huawei Batteriespeicher LUNA2000-S1"
    },
    {
      "typ": "modul",
      "familie": "sungrow-sbr",
      "schluessel": "modul",
      "preis_cents": 93700,
      "verfuegbar": true,
      "handle": "sungrow-sbr-hochspannungs-lfp-batterieserie",
      "variante_id": 59718909690190,
      "shop_variante": "3.2 kW (Nur Speichermodul SMR032 / SBR032)",
      "shop_titel": "Sungrow SBR Hochspannungs-LFP-Batterieserie SBR064-SBR256"
    },
    {
      "typ": "wr",
      "familie": "alphaess-smile-g3-s5",
      "schluessel": "g3-s5",
      "preis_cents": 140712,
      "verfuegbar": true,
      "handle": "alpha-ess-storion-wechselrichter-smile-g3-s5-5-kw",
      "variante_id": 47736588632398,
      "shop_variante": "Default Title",
      "shop_titel": "Alpha ESS Storion, Wechselrichter, SMILE-G3-S5, 5 kW"
    },
    {
      "typ": "wr",
      "familie": "alphaess-smile-g3-t12-t20",
      "schluessel": "g3-t12",
      "preis_cents": 245016,
      "verfuegbar": true,
      "handle": "alpha-ess-smile-g3-t12-wechselrichter-und-batteriespeicher-set",
      "variante_id": 55208268202318,
      "shop_variante": "G3-T12 Wechselrichter (ohne Batterie)",
      "shop_titel": "Alpha ESS Smile G3-T12 Wechselrichter und Batteriespeicher-Set"
    },
    {
      "typ": "wr",
      "familie": "alphaess-smile-g3-t12-t20",
      "schluessel": "g3-t15",
      "preis_cents": 245016,
      "verfuegbar": true,
      "handle": "alpha-ess-smile-g3-t15-wechselrichter-und-batteriespeicher-set",
      "variante_id": 55208258470222,
      "shop_variante": "G3-T15 Wechselrichter (ohne Batterie)",
      "shop_titel": "Alpha ESS Smile G3-T15 Wechselrichter und Batteriespeicher-Set"
    },
    {
      "typ": "wr",
      "familie": "alphaess-smile-g3-t12-t20",
      "schluessel": "g3-t20",
      "preis_cents": 255000,
      "verfuegbar": true,
      "handle": "alpha-ess-smile-g3-t5-wechselrichter-und-batteriespeicher-set",
      "variante_id": 55208276558158,
      "shop_variante": "G3-T20 Wechselrichter (ohne Batterie)",
      "shop_titel": "Alpha ESS Smile G3-T20 Wechselrichter und Batteriespeicher-Set"
    },
    {
      "typ": "wr",
      "familie": "alphaess-smile-g3-t4-t10",
      "schluessel": "g3-t6",
      "preis_cents": 126567,
      "verfuegbar": true,
      "handle": "alpha-ess-smile-g3-t6-wechselrichter-und-batteriespeicher-set-1",
      "variante_id": 55208274329934,
      "shop_variante": "G3-T6 Wechselrichter (ohne Batterie)",
      "shop_titel": "Alpha ESS Smile G3-T6 Wechselrichter und Batteriespeicher-Set"
    },
    {
      "typ": "wr",
      "familie": "alphaess-smile-g3-t4-t10",
      "schluessel": "g3-t10",
      "preis_cents": 148400,
      "verfuegbar": true,
      "handle": "alpha-ess-smile-g3-t10-wechselrichter-und-batteriespeicher-set",
      "variante_id": 55208271446350,
      "shop_variante": "G3-T10 Wechselrichter (ohne Batterie)",
      "shop_titel": "Alpha ESS Smile G3-T10 Wechselrichter und Batteriespeicher-Set"
    },
    {
      "typ": "wr",
      "familie": "alphaess-smile-hi10",
      "schluessel": "hi10",
      "preis_cents": 239900,
      "verfuegbar": true,
      "handle": "alphaess-smile-hi10-wechselrichter",
      "variante_id": 47637121499470,
      "shop_variante": "Default Title",
      "shop_titel": "AlphaESS SMILE-Hi10 Hybrid-Wechselrichter 10 kW"
    },
    {
      "typ": "wr",
      "familie": "deye-sun-sg-hybrid",
      "schluessel": "deye-sun-15k-sg01hp3",
      "preis_cents": 135300,
      "verfuegbar": true,
      "handle": "deye-hybrid-wechselrichter-sun-10k-sg01-3-mppt-10-kw",
      "variante_id": 49578017947982,
      "shop_variante": "Default Title",
      "shop_titel": "Deye SUN 15K-SG01HP3-EU-AM2 Hybrid-Wechselrichter, 15 kW"
    },
    {
      "typ": "wr",
      "familie": "deye-sun-sg-hybrid",
      "schluessel": "deye-sun-20k-sg01hp3",
      "preis_cents": 148598,
      "verfuegbar": true,
      "handle": "deye-hybrid-wechselrichter-sun-20k-2-mppt-20-kw-dreiphasig",
      "variante_id": 49578016506190,
      "shop_variante": "Default Title",
      "shop_titel": "DEYE Hybrid Wechselrichter SUN-20K-SG01HP3-EU-AM2, 2 MPPT, 20 KW Dreiphasig"
    },
    {
      "typ": "wr",
      "familie": "deye-sun-sg-hybrid",
      "schluessel": "deye-sun-25k-sg01hp3",
      "preis_cents": 159900,
      "verfuegbar": true,
      "handle": "deye-hybrid-wechselrichter-sun-25k-sg01hp3-eu-am2-2-mppt-20-kw-dreiphasig",
      "variante_id": 54876733112654,
      "shop_variante": "Default Title",
      "shop_titel": "DEYE Hybrid Wechselrichter SUN-25K-SG01HP3-EU-AM2, 2 MPPT, 25 KW Dreiphasig"
    },
    {
      "typ": "wr",
      "familie": "fronius-primo-gen24-plus",
      "schluessel": "primo-3.6",
      "preis_cents": 132400,
      "verfuegbar": true,
      "handle": "fronius-primo-gen24-3-6-plus-hybrid-wr-2-mppt-1-phasig",
      "variante_id": 48923176993102,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Primo GEN24 3.6 plus Hybrid-WR, 2 MPPT, 1-phasig"
    },
    {
      "typ": "wr",
      "familie": "fronius-primo-gen24-plus",
      "schluessel": "primo-4.6",
      "preis_cents": 148880,
      "verfuegbar": true,
      "handle": "fronius-primo-gen24-4-6-plus-hybrid-wr-2-mppt-1-phasig",
      "variante_id": 48923154743630,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Primo GEN24 4.6 plus Hybrid-WR, 2 MPPT, 1-phasig"
    },
    {
      "typ": "wr",
      "familie": "fronius-primo-gen24-plus",
      "schluessel": "primo-5.0",
      "preis_cents": 143295,
      "verfuegbar": true,
      "handle": "fronius-wechselrichter-primo-gen24-5-0-plus-aktiver-speicheranschluss-notstrom-pv-point-ip66-wlan",
      "variante_id": 60176209641806,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Wechselrichter PRIMO GEN24 5.0 PLUS, aktiver Speicheranschluss, Notstrom PV-Point, IP66, WLAN"
    },
    {
      "typ": "wr",
      "familie": "fronius-symo-gen24-plus",
      "schluessel": "symo-4.0",
      "preis_cents": 151736,
      "verfuegbar": true,
      "handle": "fronius-symo-gen24-4-0-plus-hybrid-wr-2-mppt-3-phasig",
      "variante_id": 48923210875214,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Symo GEN24 4.0 plus Hybrid-WR, 2 MPPT, 3-phasig"
    },
    {
      "typ": "wr",
      "familie": "fronius-symo-gen24-plus",
      "schluessel": "symo-8.0",
      "preis_cents": 260662,
      "verfuegbar": true,
      "handle": "fronius-symo-gen24-8-0-plus-hybrid-wr-2-mppt-3-phasig",
      "variante_id": 48923155366222,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Symo GEN24 8.0 plus Hybrid-WR, 2 MPPT, 3-phasig"
    },
    {
      "typ": "wr",
      "familie": "fronius-verto-plus",
      "schluessel": "verto-15.0",
      "preis_cents": 331591,
      "verfuegbar": true,
      "handle": "fronius-verto-plus-hybrid-wechselrichter-15-0-kw-3-mppt-3-phasig-ip66",
      "variante_id": 52740710793550,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Verto Plus Hybrid-Wechselrichter 15.0 kW 3 MPPT 3-phasig IP66"
    },
    {
      "typ": "wr",
      "familie": "fronius-verto-plus",
      "schluessel": "verto-17.5",
      "preis_cents": 348709,
      "verfuegbar": true,
      "handle": "fronius-verto-plus-hybrid-wechselrichter-17-5-kw-3-phasig-hochvoltspeicheranschluss-ueberspannungsschutz",
      "variante_id": 55296070418766,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Verto Plus Hybrid-Wechselrichter 17,5 kW, 3-phasig, Hochvoltspeicheranschluss, Ueberspannungsschutz"
    },
    {
      "typ": "wr",
      "familie": "fronius-verto-plus",
      "schluessel": "verto-20.0",
      "preis_cents": 371447,
      "verfuegbar": true,
      "handle": "fronius-verto-plus-20-0-hybrid-wechselrichter-3-mppt-3-phasig-20-kw-ac-400-v",
      "variante_id": 52740708401486,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Verto Plus 20.0 Hybrid-Wechselrichter 3 MPPT 3-phasig 20 kW AC 400 V"
    },
    {
      "typ": "wr",
      "familie": "fronius-verto-plus",
      "schluessel": "verto-25.0",
      "preis_cents": 366990,
      "verfuegbar": true,
      "handle": "fronius-verto-plus-hybrid-wechselrichter-25-0-kw-3-mppt-3-phasig-hochvoltspeicheranschluss-ueberspannungsschutz",
      "variante_id": 52740707221838,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Verto Plus Hybrid-Wechselrichter 25.0 kW, 3 MPPT, 3-phasig, Hochvoltspeicheranschluss, Ueberspannungsschutz"
    },
    {
      "typ": "wr",
      "familie": "fronius-verto-plus",
      "schluessel": "verto-30.0",
      "preis_cents": 432027,
      "verfuegbar": true,
      "handle": "fronius-verto-plus-30-0-hybrid-wechselrichter-3-mppt-3-phasig-30-kw",
      "variante_id": 52740706632014,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Verto Plus 30.0 Hybrid-Wechselrichter 3 MPPT 3-phasig 30 kW"
    },
    {
      "typ": "wr",
      "familie": "fronius-verto-plus",
      "schluessel": "verto-33.3",
      "preis_cents": 432927,
      "verfuegbar": true,
      "handle": "fronius-verto-plus-33-0-hybrid-wechselrichter-3-mppt-3-phasig-33-kw-ac-leistung",
      "variante_id": 52740706533710,
      "shop_variante": "Default Title",
      "shop_titel": "Fronius Verto Plus 33.0 Hybrid-Wechselrichter 3 MPPT 3-phasig 33 kW AC-Leistung"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eha-g20",
      "schluessel": "gw3-6k-eha-g20",
      "preis_cents": 79037,
      "verfuegbar": true,
      "handle": "set-goodwe-gw3-6k-eha-g20-hybrid-wechselrichter-3-6-kw-goodwe-bat-d-speicher-48-kwh-nutzbar",
      "variante_id": 59242194567502,
      "shop_variante": "Default Title",
      "shop_titel": "Set Goodwe GW3.6K-EHA-G20 Hybrid-Wechselrichter 3,6 kW + Goodwe Bat-D Speicher 48 kWh nutzbar"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eha-g20",
      "schluessel": "gw3k-eha-g20",
      "preis_cents": 77459,
      "verfuegbar": true,
      "handle": "goodwe-hybrid-wechselrichter-eha-g20-3kw-48kwh-ip66-wifi-bluetooth",
      "variante_id": 59242191028558,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe Hybrid-Wechselrichter EHA-G20 3kW, 48kWh, IP66, Wifi, Bluetooth"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eha-g20",
      "schluessel": "gw5k-eha-g20",
      "preis_cents": 82336,
      "verfuegbar": true,
      "handle": "goodwe-hybrid-wechselrichter-gw5k-eha-g20-5kw-48kwh-1-phasig-hochvolt-ip66",
      "variante_id": 59242190995790,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe Hybrid-Wechselrichter GW5K-EHA-G20 5kW, 48kWh, 1-phasig, Hochvolt, IP66"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eha-g20",
      "schluessel": "gw6k-eha-g20",
      "preis_cents": 84201,
      "verfuegbar": true,
      "handle": "goodwe-gw6k-eha-g20-hybrid-wechselrichter-6-0-kw-48-kwh-kapazitaet-ip66-schutzklasse",
      "variante_id": 59242194403662,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe GW6K-EHA-G20 Hybrid-Wechselrichter 6,0 kW, 48 kWh Kapazitaet, IP66 Schutzklasse"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eha-g20",
      "schluessel": "gw8k-eha-g20",
      "preis_cents": 91660,
      "verfuegbar": true,
      "handle": "goodwe-hybrid-wechselrichter-gw8k-eha-g20-8kw-1-phasig-bis-48kwh-speicher-ip66",
      "variante_id": 59242194239822,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe Hybrid-Wechselrichter GW8K-EHA-G20 8kW, 1-phasig, bis 48kWh Speicher, IP66"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eta-g20",
      "schluessel": "gw5k-eta-g20",
      "preis_cents": 129165,
      "verfuegbar": true,
      "handle": "goodwe-gw5k-eta-g20-hybrid-wechselrichter-5-kw-3-phasig-ip66-bis-108-kwh-speicherintegration",
      "variante_id": 60176206135630,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe GW5K-ETA-G20 Hybrid-Wechselrichter 5 kW, 3-phasig, IP66, bis 108 kWh Speicherintegration"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eta-g20",
      "schluessel": "gw6k-eta-g20",
      "preis_cents": 133980,
      "verfuegbar": true,
      "handle": "set-goodwe-gw6k-eta-g20-6kw-3-phasen-hybrid-wechselrichter-goodwe-esa-hochvolt-speicher-bis-108kwh",
      "variante_id": 60176206463310,
      "shop_variante": "Default Title",
      "shop_titel": "Set Goodwe GW6K-ETA-G20 6kW 3-Phasen Hybrid-Wechselrichter + Goodwe ESA Hochvolt-Speicher bis 108kWh"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eta-g20",
      "schluessel": "gw8k-eta-g20",
      "preis_cents": 138445,
      "verfuegbar": true,
      "handle": "goodwe-gw8k-eta-g20-hybrid-wechselrichter-8-0-kw-3-phasig-108-kwh-speicherkapazitaet-ip66-wifi-bluetooth",
      "variante_id": 59242194338126,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe GW8K-ETA-G20 Hybrid-Wechselrichter 8,0 kW, 3-phasig, 108 kWh Speicherkapazitaet, IP66, Wifi/Bluetooth"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eta-g20",
      "schluessel": "gw10k-eta-g20",
      "preis_cents": 142911,
      "verfuegbar": true,
      "handle": "goodwe-hybrid-wechselrichter-gw10k-eta-g20-10kw-3-phasig-ip66-bis-108kwh-4-mppt",
      "variante_id": 59242194108750,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe Hybrid-Wechselrichter GW10K-ETA-G20 10kW, 3-phasig, IP66, bis 108kWh, 4 MPPT"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eta-g20",
      "schluessel": "gw15k-eta-g20",
      "preis_cents": 167623,
      "verfuegbar": true,
      "handle": "goodwe-gw15k-eta-g20-hybrid-wechselrichter-15kw-3-phasig-108kwh-ip66-wifi-afci",
      "variante_id": 59242194075982,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe GW15K-ETA-G20 Hybrid-Wechselrichter 15kW, 3-phasig, 108kWh, IP66, Wifi, AFCI"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eta-g20",
      "schluessel": "gw20k-eta-g20",
      "preis_cents": 215496,
      "verfuegbar": true,
      "handle": "goodwe-hybrid-wechselrichter-gw20k-eta-g20-20kw-3-phasig-ip66-bis-108kwh-speicherintegration",
      "variante_id": 59242194010446,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe Hybrid-Wechselrichter GW20K-ETA-G20 20kW, 3-phasig, IP66, bis 108kWh Speicherintegration"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eta-g20",
      "schluessel": "gw25k-eta-g20",
      "preis_cents": 231486,
      "verfuegbar": true,
      "handle": "set-goodwe-gw25k-eta-g20-25kw-3-phasig-goodwe-bat-d-speicher-bis-108kwh-ip66-schutzklasse",
      "variante_id": 59564130599246,
      "shop_variante": "Default Title",
      "shop_titel": "Set Goodwe GW25K-ETA-G20 25kW 3-phasig + Goodwe Bat-D Speicher bis 108kWh IP66 Schutzklasse"
    },
    {
      "typ": "wr",
      "familie": "goodwe-esa-eta-g20",
      "schluessel": "gw29-999k-eta-g20",
      "preis_cents": 237358,
      "verfuegbar": true,
      "handle": "goodwe-gw29-999k-eta-g20-hybrid-wechselrichter-29-999-kw-3-phasig-4-mppt-ip66-wifi-lan-bluetooth-hochvolt-speicheranbindung",
      "variante_id": 59242193617230,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe GW29.999K-ETA-G20 Hybrid-Wechselrichter 29,999 kW, 3-phasig, 4 MPPT, IP66, Wifi, LAN, Bluetooth, Hochvolt-Speicheranbindung"
    },
    {
      "typ": "wr",
      "familie": "goodwe-et",
      "schluessel": "gw10k-et-20",
      "preis_cents": 111419,
      "verfuegbar": true,
      "handle": "goodwe-hybrid-wechselrichter-10kw-3-phasig-3-mppt-afci-ip66-notstrom-cyber-security",
      "variante_id": 55223052730702,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe Hybrid-Wechselrichter 10kW 3-phasig, 3 MPPT, AFCI, IP66, Notstrom, Cyber-Security"
    },
    {
      "typ": "wr",
      "familie": "goodwe-et",
      "schluessel": "gw12k-et-20",
      "preis_cents": 114799,
      "verfuegbar": true,
      "handle": "goodwe-hybrid-wechselrichter-12kw-3-mppt-3-phasig-afci-spd-typ-2-notstrom-ip66-wifi-lan",
      "variante_id": 54800932667726,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe Hybrid-Wechselrichter 12kW, 3 MPPT, 3-phasig, AFCI, SPD Typ 2, Notstrom, IP66, Wifi-LAN"
    },
    {
      "typ": "wr",
      "familie": "goodwe-et",
      "schluessel": "gw15k-et-20",
      "preis_cents": 110359,
      "verfuegbar": true,
      "handle": "goodwe-gw15k-et-20-g2-hybrid-wechselrichter-3-mppt-3-phasig-afci-spd-typ-2",
      "variante_id": 54491090616654,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe GW15K-ET-20 G2 Hybrid-Wechselrichter 3 MPPT, 3-phasig, AFCI, SPD Typ 2"
    },
    {
      "typ": "wr",
      "familie": "goodwe-et",
      "schluessel": "gw6000-et-20",
      "preis_cents": 126674,
      "verfuegbar": true,
      "handle": "goodwe-gw6000-et-20-g2-hybrid-wechselrichter-6kw-3-phasig-afci-ip66-wifi-lan-dongle-notstromfunktion",
      "variante_id": 55223052829006,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe GW6000-ET-20 G2 Hybrid-Wechselrichter 6kW, 3-phasig, AFCI, IP66, Wifi-LAN Dongle, Notstromfunktion"
    },
    {
      "typ": "wr",
      "familie": "goodwe-et-40-50",
      "schluessel": "gw50k-et-10",
      "preis_cents": 309558,
      "verfuegbar": true,
      "handle": "goodwe-hybrid-wechselrichter-50kw-3-phasig-dc-spd-1-2-afci-wifi-lan",
      "variante_id": 51148811731278,
      "shop_variante": "Default Title",
      "shop_titel": "Goodwe Hybrid-Wechselrichter GW50K-ET-10 50kW 3-phasig DC SPD 1+2 AFCI WIFI/LAN"
    },
    {
      "typ": "wr",
      "familie": "growatt-mid-xh",
      "schluessel": "mid-25ktl3-xh",
      "preis_cents": 151362,
      "verfuegbar": true,
      "handle": "growatt-3-phasiger-hybrid-wechselrichter-mid-25ktl3-xh-25-kw-netzeinspeisung-batterie-backup",
      "variante_id": 47578014384462,
      "shop_variante": "Default Title",
      "shop_titel": "Growatt 3-phasiger Hybrid Wechselrichter MID 25KTL3-XH, 25 kW, Netzeinspeisung, Batterie-Backup"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-m1",
      "schluessel": "sun2000-3ktl-m1",
      "preis_cents": 67618,
      "verfuegbar": true,
      "handle": "huawei-wechselrichter-sun2000-3ktl-m1-3-kw-leistung-m1-serie",
      "variante_id": 47577986826574,
      "shop_variante": "Default Title",
      "shop_titel": "Huawei Wechselrichter SUN2000-3KTL-M1, 3 kW Leistung, M1 Serie"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-m1",
      "schluessel": "sun2000-4ktl-m1",
      "preis_cents": 70850,
      "verfuegbar": true,
      "handle": "huawei-wechselrichter-sun2000-4ktl-m1-4kw-leistung-hocheffizient-integrierte-monitoring-funktion",
      "variante_id": 47577989742926,
      "shop_variante": "Default Title",
      "shop_titel": "Huawei Wechselrichter SUN2000-4KTL-M1, 4kW Leistung, hocheffizient, integrierte Monitoring-Funktion"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-m1",
      "schluessel": "sun2000-5ktl-m1",
      "preis_cents": 72003,
      "verfuegbar": true,
      "handle": "huawei-wechselrichter-5ktl-m1-5-kw-photovoltaik-solar-dc-ac-integrierter-wifi",
      "variante_id": 47577991676238,
      "shop_variante": "Default Title",
      "shop_titel": "Huawei Wechselrichter 5KTL-M1, 5 kW, Photovoltaik, Solar, DC/AC, integrierter WiFi"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-m1",
      "schluessel": "sun2000-6ktl-m1",
      "preis_cents": 79293,
      "verfuegbar": true,
      "handle": "huawei-wechselrichter-sun2000-6ktl-m1-6-kw-dreiphasig",
      "variante_id": 47577997246798,
      "shop_variante": "Default Title",
      "shop_titel": "Huawei Wechselrichter SUN2000-6KTL-M1, 6 kW, dreiphasig"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-m1",
      "schluessel": "sun2000-8ktl-m1",
      "preis_cents": 80400,
      "verfuegbar": true,
      "handle": "huawei-solar-wechselrichter-sun2000-8ktl-m1-8-kw-einphasig",
      "variante_id": 47578003374414,
      "shop_variante": "Default Title",
      "shop_titel": "Huawei Solar Wechselrichter SUN2000-8KTL-M1, 8 kW, dreiphasig"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-m1",
      "schluessel": "sun2000-10ktl-m1",
      "preis_cents": 91783,
      "verfuegbar": true,
      "handle": "huawei-wechselrichter-sun2000-10ktl-m1-10-kw-wechselrichter",
      "variante_id": 47578009272654,
      "shop_variante": "Default Title",
      "shop_titel": "Huawei Wechselrichter SUN2000-10KTL-M1, 10 kW Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-map0",
      "schluessel": "sun2000-5k-map0",
      "preis_cents": 76443,
      "verfuegbar": true,
      "handle": "huawei-hybrid-wechselrichter-sun2000-5k-map0-5kw-2-mppt-3-phasig-ip66-uberspannungsschutz-typ-2",
      "variante_id": 50824807153998,
      "shop_variante": "Default Title",
      "shop_titel": "HUAWEI Hybrid-Wechselrichter SUN2000-5K-MAP0 5kW 2 MPPT 3-phasig IP66 Überspannungsschutz Typ 2"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-map0",
      "schluessel": "sun2000-6k-map0",
      "preis_cents": 84321,
      "verfuegbar": true,
      "handle": "huawei-hybrid-wechselrichter-sun2000-6k-map0-6kw-2-mppt-3-phasig-ip66-typ-2-uberspannungsschutz",
      "variante_id": 50824804925774,
      "shop_variante": "Default Title",
      "shop_titel": "Huawei Hybrid-Wechselrichter SUN2000-6K-MAP0, 6kW, 2 MPPT, 3-phasig, IP66, Typ 2 Überspannungsschutz"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-map0",
      "schluessel": "sun2000-8k-map0",
      "preis_cents": 85598,
      "verfuegbar": true,
      "handle": "huawei-hybrid-wechselrichter-sun2000-8k-map0-8kw-2-mppt-3-phasig-ip66-uberspannungsschutz-typ-2",
      "variante_id": 50824802992462,
      "shop_variante": "Default Title",
      "shop_titel": "Huawei Hybrid-Wechselrichter SUN2000-8K-MAP0 8kW, 2 MPPT, 3-phasig, IP66, Überspannungsschutz Typ 2"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-map0",
      "schluessel": "sun2000-10k-map0",
      "preis_cents": 100588,
      "verfuegbar": true,
      "handle": "huawei-hybrid-wechselrichter-sun2000-10k-map0-10kw-2-mppt-3-phasig-ip66-wlan-lan-kompatibel",
      "variante_id": 50824800633166,
      "shop_variante": "Default Title",
      "shop_titel": "Huawei Hybrid-Wechselrichter SUN2000-10K-MAP0, 10kW, 2 MPPT, 3-phasig, IP66, WLAN/LAN-kompatibel"
    },
    {
      "typ": "wr",
      "familie": "huawei-sun2000-map0",
      "schluessel": "sun2000-12k-map0",
      "preis_cents": 111559,
      "verfuegbar": true,
      "handle": "huawei-hybrid-wechselrichter-sun2000-12k-map0-12kw-2-mppt-3-phasig-ip66",
      "variante_id": 50824799584590,
      "shop_variante": "Default Title",
      "shop_titel": "HUAWEI Hybrid-Wechselrichter SUN2000-12K-MAP0 12kW 2 MPPT 3-phasig IP66"
    },
    {
      "typ": "wr",
      "familie": "kostal-plenticore-bi-25-g3",
      "schluessel": "bi-25-g3",
      "preis_cents": 292598,
      "verfuegbar": true,
      "handle": "kostal-wechselrichter-plenticore-bi-25-g3-25-kw-3-phasen-ip65-high-voltage-ersatzstromfaehig",
      "variante_id": 60340662370638,
      "shop_variante": "Default Title",
      "shop_titel": "Kostal Wechselrichter PLENTICORE BI 25 G3 25 kW, 3 Phasen, IP65, High Voltage, Ersatzstromfaehig"
    },
    {
      "typ": "wr",
      "familie": "kostal-plenticore-g3",
      "schluessel": "g3-4.0",
      "preis_cents": 114058,
      "verfuegbar": true,
      "handle": "kostal-plenticore-g3-serie-der-modulare-hybrid-wechselrichter",
      "variante_id": 59438966899022,
      "shop_variante": "Plenticore G3 – S Hybrid-WR, 4,0-7,0 kW",
      "shop_titel": "Kostal Plenticore G3 Serie | Der modulare Hybrid-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "kostal-plenticore-g3",
      "schluessel": "g3-8.5",
      "preis_cents": 163238,
      "verfuegbar": true,
      "handle": "kostal-plenticore-g3-serie-der-modulare-hybrid-wechselrichter",
      "variante_id": 59438966931790,
      "shop_variante": "Plenticore G3 – M Hybrid-WR, 8,5-12,5 kW",
      "shop_titel": "Kostal Plenticore G3 Serie | Der modulare Hybrid-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "kostal-plenticore-g3",
      "schluessel": "g3-15",
      "preis_cents": 203638,
      "verfuegbar": true,
      "handle": "kostal-plenticore-g3-serie-der-modulare-hybrid-wechselrichter",
      "variante_id": 59438966964558,
      "shop_variante": "Plenticore G3 – L Hybrid-WR, 15,0-20,0 kW",
      "shop_titel": "Kostal Plenticore G3 Serie | Der modulare Hybrid-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "kostal-plenticore-plus-g2",
      "schluessel": "g2-3.0",
      "preis_cents": 90744,
      "verfuegbar": true,
      "handle": "kostal-plenticore-plus-g2-der-smarte-hybrid-wechselrichter",
      "variante_id": 59435939692878,
      "shop_variante": "PLENTICORE plus G2 3.0",
      "shop_titel": "Kostal Plenticore Plus G2 | Der smarte Hybrid-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "kostal-plenticore-plus-g2",
      "schluessel": "g2-4.2",
      "preis_cents": 87051,
      "verfuegbar": true,
      "handle": "kostal-plenticore-plus-g2-der-smarte-hybrid-wechselrichter",
      "variante_id": 59435939725646,
      "shop_variante": "PLENTICORE plus G2 4.2",
      "shop_titel": "Kostal Plenticore Plus G2 | Der smarte Hybrid-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "kostal-plenticore-plus-g2",
      "schluessel": "g2-5.5",
      "preis_cents": 100134,
      "verfuegbar": true,
      "handle": "kostal-plenticore-plus-g2-der-smarte-hybrid-wechselrichter",
      "variante_id": 59435939758414,
      "shop_variante": "PLENTICORE plus G2 5.5",
      "shop_titel": "Kostal Plenticore Plus G2 | Der smarte Hybrid-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "kostal-plenticore-plus-g2",
      "schluessel": "g2-7.0",
      "preis_cents": 121945,
      "verfuegbar": true,
      "handle": "kostal-plenticore-plus-g2-der-smarte-hybrid-wechselrichter",
      "variante_id": 59435939791182,
      "shop_variante": "PLENTICORE plus G2 7.0",
      "shop_titel": "Kostal Plenticore Plus G2 | Der smarte Hybrid-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "kostal-plenticore-plus-g2",
      "schluessel": "g2-8.5",
      "preis_cents": 134370,
      "verfuegbar": true,
      "handle": "kostal-plenticore-plus-g2-der-smarte-hybrid-wechselrichter",
      "variante_id": 59435939823950,
      "shop_variante": "PLENTICORE plus G2 8.5",
      "shop_titel": "Kostal Plenticore Plus G2 | Der smarte Hybrid-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "kostal-plenticore-plus-g2",
      "schluessel": "g2-10.0",
      "preis_cents": 148600,
      "verfuegbar": true,
      "handle": "kostal-plenticore-plus-g2-der-smarte-hybrid-wechselrichter",
      "variante_id": 59435939856718,
      "shop_variante": "PLENTICORE plus G2 10.0",
      "shop_titel": "Kostal Plenticore Plus G2 | Der smarte Hybrid-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "sma-sunny-island",
      "schluessel": "si-6-0h",
      "preis_cents": 233214,
      "verfuegbar": true,
      "handle": "sma-si-6-0h-13-alu-white-batteriewechselrichter-sma-si-6-0h-13",
      "variante_id": 48923443167566,
      "shop_variante": "Default Title",
      "shop_titel": "SMA SI 6.0H-13 ALU-WHITE Batteriewechselrichter SMA SI 6.0H-13"
    },
    {
      "typ": "wr",
      "familie": "sma-sunny-tripower-smart-energy",
      "schluessel": "stpse-5.0",
      "preis_cents": 94318,
      "verfuegbar": true,
      "handle": "sma-sunny-tripower-smart-energy-5-0-6-0-8-0-10-0-hybrid-wechselrichter",
      "variante_id": 59566050115918,
      "shop_variante": "Sunny Tripower 5.0 Smart Energy",
      "shop_titel": "SMA Sunny Tripower Smart Energy 5.0/6.0/8.0/10.0 Hybrid Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "sma-sunny-tripower-smart-energy",
      "schluessel": "stpse-6.0",
      "preis_cents": 126472,
      "verfuegbar": true,
      "handle": "sma-sunny-tripower-smart-energy-5-0-6-0-8-0-10-0-hybrid-wechselrichter",
      "variante_id": 59566050148686,
      "shop_variante": "Sunny Tripower 6.0 Smart Energy",
      "shop_titel": "SMA Sunny Tripower Smart Energy 5.0/6.0/8.0/10.0 Hybrid Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "sma-sunny-tripower-smart-energy",
      "schluessel": "stpse-8.0",
      "preis_cents": 154291,
      "verfuegbar": true,
      "handle": "sma-sunny-tripower-smart-energy-5-0-6-0-8-0-10-0-hybrid-wechselrichter",
      "variante_id": 59566050181454,
      "shop_variante": "Sunny Tripower 8.0 Smart Energy",
      "shop_titel": "SMA Sunny Tripower Smart Energy 5.0/6.0/8.0/10.0 Hybrid Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "sma-sunny-tripower-smart-energy",
      "schluessel": "stpse-10.0",
      "preis_cents": 182000,
      "verfuegbar": true,
      "handle": "sma-sunny-tripower-smart-energy-5-0-6-0-8-0-10-0-hybrid-wechselrichter",
      "variante_id": 59566050214222,
      "shop_variante": "Sunny Tripower 10.0 Smart Energy",
      "shop_titel": "SMA Sunny Tripower Smart Energy 5.0/6.0/8.0/10.0 Hybrid Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "solaredge-home-hub-1ph",
      "schluessel": "se3000h",
      "preis_cents": 51870,
      "verfuegbar": true,
      "handle": "solaredge-1ph-home-hub-wechselrichter-3kw-1-phase-3kw-2-mppt-ip65-home-hub",
      "variante_id": 47302686376270,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge Home Hub Wechselrichter, einphasig, 3kW"
    },
    {
      "typ": "wr",
      "familie": "solaredge-home-hub-1ph",
      "schluessel": "se3680h",
      "preis_cents": 39000,
      "verfuegbar": true,
      "handle": "solaredge-1ph-3-68kw-heim-hub-wechselrichter",
      "variante_id": 47578001441102,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge 1PH 3,68kW Heim-Hub Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "solaredge-home-hub-1ph",
      "schluessel": "se4000h",
      "preis_cents": 51870,
      "verfuegbar": true,
      "handle": "solaredge-1ph-home-hub-wechselrichter-4-kw-wechselrichter",
      "variante_id": 47578004291918,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge 1PH Home Hub Wechselrichter, 4 kW, Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "solaredge-home-hub-1ph",
      "schluessel": "se5000h",
      "preis_cents": 39000,
      "verfuegbar": true,
      "handle": "solaredge-1-phasen-home-hub-wechselrichter-5kw-wechselrichter-1-phasen-home-hub-5kw",
      "variante_id": 47578008158542,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge 1-Phasen Home Hub Wechselrichter, 5kW, Wechselrichter 1-Phasen, Home Hub, 5kW"
    },
    {
      "typ": "wr",
      "familie": "solaredge-home-hub-1ph",
      "schluessel": "se6000h",
      "preis_cents": 39000,
      "verfuegbar": true,
      "handle": "solaredge-1ph-home-hub-wechselrichter-6-kw-fur-heimanlagen",
      "variante_id": 47578014777678,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge 1PH Home Hub Wechselrichter, 6 kW, für Heimanlagen"
    },
    {
      "typ": "wr",
      "familie": "solaredge-home-hub-3ph",
      "schluessel": "se5k-rwb48",
      "preis_cents": 130509,
      "verfuegbar": true,
      "handle": "solaredge-home-hub-3ph-wechselrichter-5-kw-fur-pv-anlagen",
      "variante_id": 47578025197902,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge Home Hub 3PH Wechselrichter, 5 kW, für PV-Anlagen"
    },
    {
      "typ": "wr",
      "familie": "solaredge-home-hub-3ph",
      "schluessel": "se8k-rwb48",
      "preis_cents": 144810,
      "verfuegbar": true,
      "handle": "solaredge-home-hub-wechselrichter-3ph-backup-mit-solaredge-home-network-8kw-3-phase-8kw-2-mppt-ip65-fur-speicherung-und-backup",
      "variante_id": 47302705185102,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge Home Hub Wechselrichter, dreiphasig, Backup mit SolarEdge Home Network, 8kW"
    },
    {
      "typ": "wr",
      "familie": "solaredge-home-hub-3ph",
      "schluessel": "se10k-rwb48",
      "preis_cents": 170750,
      "verfuegbar": true,
      "handle": "solaredge-home-hub-wechselrichter-3ph-backup-mit-solaredge-home-network-10kw-3-phase-10kw-2-mppt-ip65-fur-speicherung-und-backup",
      "variante_id": 47302704857422,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge Home Hub Wechselrichter, dreiphasig, Backup mit SolarEdge Home Network, 10kW"
    },
    {
      "typ": "wr",
      "familie": "solaredge-storedge-3ph",
      "schluessel": "se7k-rws",
      "preis_cents": 92032,
      "verfuegbar": true,
      "handle": "solaredge-se7k-rws-storedge-hybrid-storedge-dreiphasen-wechselrichter",
      "variante_id": 48923506901326,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge SE7K-RWS STOREDGE HYBRID StorEdge Dreiphasen-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "solaredge-storedge-3ph",
      "schluessel": "se8k-rws",
      "preis_cents": 93312,
      "verfuegbar": true,
      "handle": "solaredge-se8k-rws-storedge-hybrid-storedge-dreiphasen-wechselrichter",
      "variante_id": 48923508212046,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge SE8K-RWS STOREDGE HYBRID StorEdge Dreiphasen-Wechselrichter"
    },
    {
      "typ": "wr",
      "familie": "solaredge-storedge-3ph",
      "schluessel": "se10k-rws",
      "preis_cents": 117983,
      "verfuegbar": true,
      "handle": "solaredge-3ph-storedge-wechselrichter-10-0-kw-fur-photovoltaikanlagen",
      "variante_id": 47578027131214,
      "shop_variante": "Default Title",
      "shop_titel": "SolarEdge 3PH StorEdge Wechselrichter, 10.0 kW, für Photovoltaikanlagen"
    },
    {
      "typ": "wr",
      "familie": "solax-x3-ies",
      "schluessel": "x3-ies-10k",
      "preis_cents": 172365,
      "verfuegbar": true,
      "handle": "solax-wechselrichter-x3-ies-10k-10kw-3-phasig-32a-eingangsstrom-eps-backup-ip66",
      "variante_id": 55230527471950,
      "shop_variante": "Default Title",
      "shop_titel": "SolaX Wechselrichter X3-IES-10K 10kW, 3-phasig, 32A Eingangsstrom, EPS Backup, IP66"
    },
    {
      "typ": "wr",
      "familie": "solax-x3-ies",
      "schluessel": "x3-ies-12k",
      "preis_cents": 173971,
      "verfuegbar": true,
      "handle": "solax-wechselrichter-x3-ies-12k-12kw-3-phasig-typ-ii-afci-ip66-eps-backup-wlan-lan",
      "variante_id": 55230525997390,
      "shop_variante": "Default Title",
      "shop_titel": "SolaX Wechselrichter X3-IES-12K 12kW 3-phasig, Typ II/AFCI, IP66, EPS Backup, WLAN/LAN"
    },
    {
      "typ": "wr",
      "familie": "solax-x3-ies",
      "schluessel": "x3-ies-15k",
      "preis_cents": 192975,
      "verfuegbar": true,
      "handle": "solax-wechselrichter-x3-ies-15k-15kw-3-phasig-afci-ip66-eps-backup-typ-ii-schutz",
      "variante_id": 55230526849358,
      "shop_variante": "Default Title",
      "shop_titel": "SolaX Wechselrichter X3-IES-15K 15kW 3-phasig, AFCI, IP66, EPS Backup, Typ II Schutz"
    },
    {
      "typ": "wr",
      "familie": "sungrow-sh-rt",
      "schluessel": "sh-6.0rt",
      "preis_cents": 75492,
      "verfuegbar": true,
      "handle": "sungrow-hybrid-wechselrichter-sh6-0rt-20-v11-6-0-kw-2-mppt-3-phasig-ip65-10-jahre-garantie",
      "variante_id": 52740713316686,
      "shop_variante": "Default Title",
      "shop_titel": "Sungrow Hybrid-Wechselrichter SH6.0RT-20-V11 6.0 kW, 2 MPPT, 3-phasig, IP65, 10 Jahre Garantie"
    },
    {
      "typ": "wr",
      "familie": "sungrow-sh-rt",
      "schluessel": "sh-8.0rt",
      "preis_cents": 77652,
      "verfuegbar": true,
      "handle": "sungrow-hybrid-wechselrichter-8-0-kw-3-phasig-2-mppt-ip65-10-jahre-garantie",
      "variante_id": 52678547407182,
      "shop_variante": "Default Title",
      "shop_titel": "Sungrow Hybrid-Wechselrichter SH8.0RT 8,0 kW 3-phasig, 2 MPPT, IP65, 10 Jahre Garantie"
    },
    {
      "typ": "wr",
      "familie": "sungrow-sh-rt",
      "schluessel": "sh-10rt",
      "preis_cents": 82680,
      "verfuegbar": true,
      "handle": "sungrow-hybrid-wechselrichter-sh10rt-20-10kw-98-4-effizienz-typ-ii-schutz-bms-wifi-27kg",
      "variante_id": 51030324773198,
      "shop_variante": "Default Title",
      "shop_titel": "Sungrow Hybrid Wechselrichter SH10RT-20 10kW, 98.4% Effizienz, Typ-II Schutz, BMS, WiFi, 27kg"
    },
    {
      "typ": "wr",
      "familie": "sungrow-sh-t",
      "schluessel": "sh25t",
      "preis_cents": 217341,
      "verfuegbar": true,
      "handle": "sungrow-sh15-20-25t-hybrid-wechselrichter-serie-15-kw-20-kw-25-kw",
      "variante_id": 60034131362126,
      "shop_variante": "Sungrow Hybrid Wechselrichter SH25T, 25kW",
      "shop_titel": "Sungrow SH15/20/25T Hybrid-Wechselrichter Serie (15 kW / 20 kW / 25 kW)"
    },
    {
      "typ": "wr",
      "familie": "sungrow-sh5-12t",
      "schluessel": "sh5t",
      "preis_cents": 98421,
      "verfuegbar": true,
      "handle": "sungrow-sh5t-hybrid-wechselrichter-5kw-2-mppt-3-phasig-ip65-backup-63a-ueberspannungsschutz-typ-2",
      "variante_id": 60340660535630,
      "shop_variante": "Default Title",
      "shop_titel": "Sungrow SH5T Hybrid-Wechselrichter 5kW, 2 MPPT, 3-phasig, IP65, Backup 63A, Ueberspannungsschutz Typ 2"
    },
    {
      "typ": "wr",
      "familie": "sungrow-sh5-12t",
      "schluessel": "sh6t",
      "preis_cents": 82609,
      "verfuegbar": false,
      "handle": "sungrow-sh6t-hybrid-wechselrichter-6kw-3-phasig-2-mppt-ip65-ueberspannungsschutz-typ-2",
      "variante_id": 60340660961614,
      "shop_variante": "Default Title",
      "shop_titel": "Sungrow SH6T Hybrid-Wechselrichter 6kW, 3-phasig, 2 MPPT, IP65, Ueberspannungsschutz Typ 2"
    },
    {
      "typ": "wr",
      "familie": "sungrow-sh5-12t",
      "schluessel": "sh8t",
      "preis_cents": 92935,
      "verfuegbar": false,
      "handle": "sungrow-sh8t-hybrid-wechselrichter-8-kw-2-mppt-3-phasig-backup-bis-63-a-ip65-10-jahre-garantie",
      "variante_id": 60340661322062,
      "shop_variante": "Default Title",
      "shop_titel": "Sungrow SH8T Hybrid-Wechselrichter 8 kW, 2 MPPT, 3-phasig, Backup bis 63 A, IP65, 10 Jahre Garantie"
    },
    {
      "typ": "wr",
      "familie": "sungrow-sh5-12t",
      "schluessel": "sh12t",
      "preis_cents": 177815,
      "verfuegbar": true,
      "handle": "sungrow-sh12t-hybrid-wechselrichter-12-kw-2-mppt-ip65-backup-bis-63-a-ueberspannungsschutz-typ-2",
      "variante_id": 60340661911886,
      "shop_variante": "Default Title",
      "shop_titel": "Sungrow SH12T Hybrid-Wechselrichter 12 kW, 2 MPPT, IP65, Backup bis 63 A, Ueberspannungsschutz Typ 2"
    }
    ],
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = PREISE;
  if (root) root.IVBeraterPreise = PREISE;
})(typeof window !== 'undefined' ? window : null);
